<template>
    <label
        class="vue-custom-checkbox"
        :class="{ checked: content, disabled: disabled }"
        @click="toggle"
    >
        <div
            class="dummy-checkbox"
            ref="check"
            :class="{ checked: content, disabled: disabled }"
        ></div>
        <slot></slot>
    </label>
</template>

<script>
export default {
    name: "CustomCheckbox",
    props: ["value", "disabled"],
    data() {
        return {
            content: this.value == true,
        };
    },
    watch: {
        value(val) {
            if (this.content != val) {
                this.content = val;
            }
        },
    },
    methods: {
        toggle() {
            if (this.disabled) return;
            this.content = !this.content;
            this.$emit("input", this.content);
        },
    },
    mounted() {},
};
</script>

<style lang="scss">
.vue-custom-checkbox {
    display: flex;
    font-size: 1rem;
    margin: 0;
    align-items: center;

    .dummy-checkbox {
        margin-right: 0.5rem;
        cursor: pointer;
        height: 1rem;
        width: 1rem;
        border-radius: 3px;
        border: 1px solid #c3c3c3;
        box-shadow: 0 0 0 2px inset white;
        transition: all 150ms ease;

        &.disabled {
            opacity: 0.5;
            border: 1px solid #c3c3c3!important;
        }

        &.checked {
            background-color: #f2b12d;
        }

        &:hover {
            border: 1px solid #f2b12d;
        }
    }
}
</style>